import palette from 'theme/palette';

export default {
  root: {
    '&$disabled': {
      color: 'rgba(0, 0, 0, 0.6)',
    },
  },
};
